export const DisplayStateType = {
  SMALL: "small",
  LARGE: "large",
  MINIMIZED: "minimized",
} as const
